import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-aboutus',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './aboutus.component.html',
  styleUrl: './aboutus.component.scss'
})
export class AboutusComponent implements OnInit {

  constructor(
    private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    const aboutSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/aboutus",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(aboutSchema);
    this.renderer.appendChild(this.document.head, script);

    this.titleService.setTitle('About Us NCARE IVF Centre | Trusted Fertility Clinic in Kannur');
    this.metaService.updateTag({
      name: 'description',
      content: 'Learn about NCARE IVF Centre in Kannur, a trusted fertility clinic offering expert IVF, IUI, and personalized care to help you start your family.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'Trusted Fertility Clinic in Kannur, NCARE IVF Centre, fertility clinic Kannur, IVF specialists, infertility treatment, Kannur healthcare, Best fertility Hospital near me'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'About Us NCARE IVF Centre | Trusted Fertility Clinic in Kannur'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Learn about NCARE IVF Centre in Kannur, a trusted fertility clinic offering expert IVF, IUI, and personalized care to help you start your family.'
    });
  }

}